import {  useCallback, useEffect } from 'react'

import '@hotmart/cosmos/dist/dropdown'
import '@hotmart/cosmos/dist/select'

import i18n from 'src/i18n';
import { useSelectRef } from './hooks'
import { SelectOption } from './selectOption'
import { SelectProps } from './types'

const Select = ({
  name,
  onChange,
  items,
  children,
  placeholder,
  label,
  className,
  selected
}: SelectProps) => {
  const { selectRef } = useSelectRef<JSX.IntrinsicElements['hot-select']>()
  const changeHandler = (e: Event) => onChange(e as CustomEvent)

  useEffect(() => {
    const hotSelect = document.querySelector('hot-select')
    hotSelect?.addEventListener('change', changeHandler)

    return () => {
      hotSelect?.removeEventListener('change', changeHandler)
    }
  }, [onChange])

  const isSelected = useCallback(
    (value: string | number) => {
      
      if (typeof value === 'number'){
        return Number(value) === Number(selected) || undefined
      }
      return value === selected || undefined
    },
    [selected]
  )

  if (!items && !children) {
    throw new Error(i18n.t('errors.components.select'))
  }

  return (
    <div className={className}>
      {label && (
        <label htmlFor={name} className='hot-form__label'>
          {label}
        </label>
      )}
      <hot-select id={name} class='_w-full' placeholder={placeholder} ref={selectRef}>
        <div className='_hot-scroll'>
          {items?.length? items.map((item, index) => (
            <SelectOption 
              key={item.label}
              dataTest={`option-${index}`}
              value={item.value}
              isSelected={isSelected(item.value)}>
                {item.label}
              </SelectOption>
          )): null}
          {children ? children : null}
        </div>
      </hot-select>
    </div>
  )
}

Select.Option = SelectOption

export default Select